/* eslint-disable no-undef */
import $ from "jquery";
import flatpickr from "flatpickr";

const form = () => {
    const init = () => {
        showHideAdditional();
        getModelType();
        submitForm();
    };

    const showHideAdditional = () => {
        const el = {
            button: ".js-ShowHideAdditional",
            input: ".VulAutogegevensIn .Additional__Input",
            inputWrapper: ".VulAutogegevensIn .Additional__Input__Wrapper",
            btnRemove: ".VulAutogegevensIn .Additional__Input__Remove",
            btnAdd: ".VulAutogegevensIn .Additional__Input__Add",
            btnAddOutside:
                ".VulAutogegevensIn .Additional__Input__Add--Outside",
            selectAcc:
                ".VulAutogegevensIn .Additional__Input__Wrapper__SelectAccessories",
            datePlan: "#inspection-date-plan",
            selectParkBijvelds:
                ".VulAutogegevensIn__Form__Select #park-on-bijvelds",
            selectIfLease: ".VulAutogegevensIn__Form__Select #is-lease",
            outstandingBalance:
                ".VulAutogegevensIn__Form__Input #outstanding-balance",
            placeLease: ".VulAutogegevensIn__Form__Input #place-lease",
        };

        if ($(el.button).length === 0) return;

        // show date if select 'Nee' on 'Kunt u uw auto stallen op Bijvelds Locatie?'
        // $(document).on("change", el.selectParkBijvelds, function () {
        //     const optionVal = $(this).find("option:selected").val();
        //     const parent = $(this)
        //         .parent(".VulAutogegevensIn__Form__Select")
        //         .first();

        //     if (optionVal == "false") {
        //         $("#inspection-date-plan-wrapper").show();
        //         // $(el.datePlan).prop("required", true);
        //         $(parent).addClass("Form__Field--50");
        //     } else {
        //         $("#inspection-date-plan-wrapper").hide();
        //         // $(el.datePlan).removeAttr("required");
        //         $(parent).removeClass("Form__Field--50");
        //     }
        // });

        // show 2 fields if select 'Ja' on 'Loopt er een leascontract?'
        $(document).on("change", el.selectIfLease, function () {
            const optionVal = $(this).find("option:selected").val();

            if (optionVal == "true") {
                $("#place-lease-wrapper").show();
                $("#outstanding-balance-wrapper").show();
                // $(el.outstandingBalance).prop("required", true);
                // $(el.placeLease).prop("required", true);
            } else {
                $("#place-lease-wrapper").hide();
                $("#outstanding-balance-wrapper").hide();
                // $(el.outstandingBalance).removeAttr("required");
                // $(el.placeLease).removeAttr("required");
            }
        });

        $(window).on("load", function () {
            flatpickr(el.datePlan, {
                dateFormat: "Y-m-d H:i:S",
                disableMobile: true,
                enableTime: true,
                altInput: true,
                altFormat: "Y-m-d H:i",
                allowInput: true,
                onReady: function () {
                    // Add an input event listener to validate the entered date
                    document
                        .getElementById("inspection-date-plan")
                        .addEventListener("input", function (event) {
                            const input = event.target;
                            const value = input.value;
                            // Use a regular expression to match the "d-m-Y" format
                            const validFormat =
                                /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(value);
                            if (!validFormat) {
                                // If the input doesn't match the format, clear the input
                                input.value = "";
                            }
                        });
                },
                parseDate: (datestr) => {
                    return new Date(datestr);
                },
            });
        });

        $(document).on("change", el.selectAcc, function () {
            const optionVal = $(this).find("option:selected").val();
            const currId = $(this).attr("id");
            const currIdArr = currId.split("-");
            const currIndex = currIdArr[3];
            const classOtherAccEl = `.js-OtherAcc#additional-accessories-others-${currIndex}`;
            const otherAccEl = $(classOtherAccEl);

            if (optionVal == "anders") {
                $(otherAccEl).show();
                $(otherAccEl).prop("required", true);
            } else {
                $(otherAccEl).hide();
                $(otherAccEl).removeAttr("required");
            }
        });

        $(document).on("click", el.button, function (e) {
            e.preventDefault();

            const target = $(this).data("target");
            $(this).removeClass("active");
            $(`#${target}`).addClass("active");
        });

        $(document).on("click", el.btnRemove, function (e) {
            e.preventDefault();

            const target = $(this).data("target");
            const targetArr = target.split("-");
            const targetWithoutIndex = targetArr[0] + "-" + targetArr[1];

            const parentTarget = `.Additional__Input--${targetWithoutIndex} .Additional__Input__Wrapper`;

            if ($(parentTarget).length === 1) {
                $(`#input-${targetWithoutIndex}`).removeClass("active");
                $(`#placeholder-${targetWithoutIndex}`).addClass("active");
                $(`${parentTarget} input, ${parentTarget} select`).val("");
            } else {
                if ($(parentTarget).length === 2) {
                    const _elOutside = `${el.btnAddOutside}[data-target="${targetWithoutIndex}"]`;
                    const _elAdd = `${el.btnAdd}[data-target="${targetWithoutIndex}"]`;

                    $(_elOutside).removeClass("active");
                    $(_elAdd).addClass("active");
                }
                $(`#input-${target}`).remove();
            }
        });

        $(document).on(
            "click",
            [el.btnAdd, el.btnAddOutside].join(","),
            function (e) {
                e.preventDefault();

                const target = $(this).data("target");
                const lastIndex = $(
                    `#input-${target} .Additional__Input__Wrapper:last-child`,
                ).data("index");

                const listItemTemplate = $(
                    `#${target}__template-list-item`,
                ).html();

                if (!listItemTemplate) return;

                const listItem = listItemTemplate.replace(
                    /{{index}}/g,
                    lastIndex + 1,
                );

                $(`${el.input}#input-${target}`).append(listItem);
                $(`${el.btnAddOutside}[data-target="${target}"]`).addClass(
                    "active",
                );
                $(`${el.btnAdd}[data-target="${target}"]`).removeClass(
                    "active",
                );
            },
        );
    };

    const getModelType = () => {
        $(window).on("load", function () {
            const model = $("#js-car-model").val();
            const type = $("#js-car-type").val();
            if (model) {
                $("#" + model).trigger("click");
                $("#merk-select").val(type);
            }
        });
    };

    const submitForm = () => {
        $(document).on("click", "#js-btn_submit", function () {
            const form_data = $("#js-SellTheCar__Form").serialize();
            $("body").addClass("mi-loading");
            $.ajax({
                type: "POST",
                url: themeObj.ajaxUrl,
                data: {
                    form_data: form_data,
                    nonce: themeObj.products.nonce,
                    action: themeObj.products.action.add,
                },
                success: function () {
                    $("body").removeClass("mi-loading");
                    $("#popup-notification-success_submit_form").toggleClass(
                        "active",
                    );
                },
                error: (err) => {
                    console.error(err);
                    console.error(err.responseJSON.data);
                    $("body").removeClass("mi-loading");
                    $("#popup-notification-failed_submit_form").toggleClass(
                        "active",
                    );
                    $("#popup-notification-failed_submit_form")
                        .find(".PopupNotification__Content__Text__Subtitle")
                        .text(err.responseJSON.data);
                },
            });
        });
    };

    init();
};

try {
    form();
} catch (error) {
    console.error("form: ", error);
}
